import { hasPostProgramAccess, postProgramAccessUntil } from '@tfa/shared'

/**
 * Текст верхнего баннера для клиента с завершённой программой.
 *
 * После завершения клиенту на срок пост-программного доступа остаются лекции и
 * программа тренировок с аналитикой (без питания и геймификации) — баннер
 * говорит, что именно доступно и до какого числа. Когда срок вышел, остаётся
 * прежний «режим просмотра».
 */
export function completedBannerText(
  completedAt: string | Date | null | undefined,
  product: string | null | undefined,
  now: Date = new Date(),
): string {
  // #646: у Клуба пост-программного срока нет — сразу режим просмотра.
  if (product === 'CLUB') return 'Подписка на Клуб закончилась — режим просмотра'
  const until = postProgramAccessUntil(completedAt, product)
  if (!until || !hasPostProgramAccess(completedAt, product, now)) {
    return 'Программа завершена — режим просмотра'
  }
  const date = until.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', timeZone: 'UTC' })
  return `Программа завершена — лекции и тренировки доступны до ${date}`
}
